const es = {
  common: {
    loading: 'Cargando...',
    error: 'Algo salió mal',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
    copy: 'Copiar',
    copied: '¡Copiado!',
    goHome: 'Ir al inicio',
    back: 'Atrás',
    playAudyn: 'Jugar Audyn',
    reload: 'Recargar',
    or: 'o',
    you: 'tú',
    vs: 'VS',
    songs: 'Canciones',
    tracks: 'pistas',
    score: 'Puntos',
    rank: 'Rango',
    correct: 'Correcto',
    accuracy: 'Precisión',
    today: 'hoy',
    daily: 'Diario',
    streak: 'Racha',
    profile: 'Perfil',
    guest: 'Invitado',
  },

  nav: {
    dailyChallenge: 'Desafío diario',
    leaderboard: 'Clasificación',
    profile: 'Perfil',
    logIn: 'Iniciar sesión',
  },

  home: {
    title: 'Adivina la canción',
    subtitle: 'Pega una playlist de Spotify. Escucha un clip. Nombra la canción.',
    playersToday: '{count} jugador{s} hoy',
    playlistInput: 'https://open.spotify.com/playlist/...',
    loadPlaylist: 'Cargar playlist',
    tryDemo: 'Prueba un demo — Today\'s Top Hits',
    recentlyPlayed: 'Escuchado recientemente',
    featuredPlaylists: 'Playlists populares',
    songs: 'Canciones',
    difficulty: 'Dificultad',
    gameMode: 'Modo de juego',
    guessMode: 'Modo de adivinanza',
    clips: 'Clips',
    startGame: 'INICIAR JUEGO',
    challengeFriend: '⚔️ Desafiar a un amigo',
    changePlaylist: 'Cambiar playlist',
    playableTracks: '{count} pistas reproducibles',
    playableOfTotal: '{playable} de {total} pistas reproducibles',
    allGuessable: 'Las {total} están en la lista de respuestas',
    loadingPreviews: 'Cargando fragmentos…',
    back: 'Atrás',
    backToPlaylist: 'Volver a selección de playlist',

    beatScore: '⚔️ ¡Supera la puntuación de {username} de {score}!',

    announcement: {
      title: '🎉 ¡Ahora compatible con playlists grandes!',
      message: 'Las playlists con 100+ canciones ahora son compatibles. Pueden tardar un poco en cargar.',
    },

    easy: 'Fácil',
    easyDesc: 'Clips más largos, más tiempo para pensar',
    normal: 'Normal',
    normalDesc: 'La experiencia clásica',
    hard: 'Difícil',
    hardDesc: 'Parpadea y te lo pierdes',
    classic: 'Clásico',
    classicDesc: 'Puntuación solo por etapa de clip. Sin presión de tiempo.',
    tickingAway: 'Contrarreloj',
    tickingAwayDesc: 'Tu puntuación baja con cada segundo. Cada momento cuenta.',
    songTitle: 'Título de la canción',
    songTitleDesc: 'Nombra la pista',
    artist: 'Artista',
    artistDesc: 'Nombra al artista',
  },

  game: {
    tapToBegin: 'TOCA PARA EMPEZAR',
    tapToUnlock: 'Toca en cualquier lugar para desbloquear el audio',
    listening: 'ESCUCHANDO...',
    ready: 'LISTO',
    tapReplay: 'Toca para repetir',
    loadingAudio: 'CARGANDO...',
    skipped: 'SALTADO',
    audioError: 'ERROR DE AUDIO',
    typeGuess: 'Escribe tu respuesta...',
    typeArtist: 'Escribe el nombre del artista...',
    checking: 'Comprobando...',
    skip: 'Saltar',
    timePressure: 'Presión de tiempo',
    nextSong: 'SIGUIENTE CANCIÓN',
    seeResults: 'VER RESULTADOS',
    betterLuck: 'Mejor suerte la próxima vez',
    correctArtist: '¡Artista correcto!',
    theArtistWas: 'El artista era: {artist}',
    openInSpotify: 'Abrir en Spotify',
    base: 'base',
    timePenalty: 'penalización',
    streakMultiplier: '× {mult} racha',
    kbPlay: '[Espacio] Reproducir',
    kbGuess: '[Enter] Adivinar',
    kbClear: '[Esc] Limpiar',
  },

  end: {
    newPersonalBest: '🏆 ¡NUEVO RÉCORD PERSONAL!',
    copyLink: 'Copiar enlace',
    copyShareText: 'Copiar texto',
    challengeFriend: 'Desafiar a un amigo',
    copyManually: 'Copiar manualmente:',
    playAgain: 'Jugar de nuevo',
    newPlaylist: 'Nueva playlist',
    viewLeaderboard: 'Ver clasificación',
    createAccount: 'Crea una cuenta para guardar tus puntuaciones y ganar insignias',
    signUp: 'Registrarse',
    outOf: 'de {max}',
    missedTracks: 'Pistas falladas',
    scoreCard: 'Tarjeta de puntuación',
    shareText: 'Obtuve {score}/{max} en {playlist} 🎵 ({difficulty} • {tracks} canciones) — ¿puedes ganarme? {link}',
  },

  daily: {
    title: 'DESAFÍO DIARIO',
    todaysChallenge: 'Desafío de hoy',
    classicMode: '🎵 Modo clásico • Sin presión de tiempo',
    playToday: 'Jugar el desafío de hoy',
    alreadyPlayed: '✅ Ya completaste el desafío de hoy',
    signInToSave: 'Inicia sesión para guardar tu racha diaria',
    firstDay: '¡Primer día! Sigue así.',
    dayStreak: 'Racha de {count} días',
    couldNotLoad: 'No se pudo cargar el desafío diario',
    needsCache: 'La playlist diaria necesita reproducirse una vez para llenar la caché.',
    alreadyPlayedToast: '¡Ya jugaste el desafío de hoy!',
  },

  leaderboard: {
    title: 'CLASIFICACIÓN',
    global: '🏆 Global',
    daily: '📅 Diario',
    allTime: 'Todo el tiempo',
    month: 'Mes',
    week: 'Semana',
    noEntries: 'Sin entradas aún',
    beFirst: '¡Sé el primero en jugar y ganar tu lugar!',
    yourRank: 'Tu rango',
    rankedByTimePressure: 'Clasificado por puntuación bajo presión de tiempo',
    classicMode: '🎵 Clásico',
    tickingMode: '⏱️ Contrarreloj',
    songMode: '🎵 Título',
    artistMode: '🎤 Artista',
  },

  login: {
    title: 'Iniciar sesión',
    email: 'Correo electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    password: 'Contraseña',
    passwordPlaceholder: '••••••••',
    logInBtn: 'Iniciar sesión',
    signingIn: 'Iniciando sesión...',
    noAccount: '¿No tienes cuenta?',
    signUpLink: 'Regístrate',
    welcomeBack: '¡Bienvenido de vuelta!',
    fillFields: 'Por favor completa todos los campos',
    loginFailed: 'Error al iniciar sesión',
  },

  register: {
    title: 'Registrarse',
    saveProgress: 'Guarda tu progreso',
    saveProgressDesc: 'Crea una cuenta para mantener tus puntuaciones en la clasificación.',
    username: 'Nombre de usuario',
    usernamePlaceholder: 'tu_usuario',
    email: 'Correo electrónico',
    emailPlaceholder: 'tu@ejemplo.com',
    password: 'Contraseña',
    passwordPlaceholder: 'Mínimo 8 caracteres',
    bio: 'Biografía',
    bioPlaceholder: 'Algo sobre ti...',
    optional: 'opcional',
    createAccount: 'Crear cuenta',
    saveAccount: 'Guardar cuenta',
    creating: 'Creando...',
    haveAccount: '¿Ya tienes cuenta?',
    logInLink: 'Iniciar sesión',
    welcomeToAudyn: '¡Bienvenido a Audyn!',
    accountCreated: '¡Cuenta creada! Tus puntuaciones se han conservado.',
    fillRequired: 'Por favor completa todos los campos requeridos',
    passwordMin: 'La contraseña debe tener al menos 8 caracteres',
    registrationFailed: 'Error en el registro',
  },

  profile: {
    title: 'PERFIL',
    editProfile: 'Editar perfil',
    displayName: 'Nombre visible',
    displayNamePlaceholder: 'Nombre visible (opcional)',
    displayNameHint: '{count}/50 — Deja en blanco para mostrar tu usuario',
    bioPlaceholder: 'Escribe una breve biografía...',
    spotify: 'Spotify',
    spotifyPlaceholder: 'https://open.spotify.com/user/your_id',
    spotifyError: 'Debe comenzar con https://open.spotify.com/user/',
    instagram: 'Instagram',
    instagramError: 'Solo letras, dígitos, guiones bajos y puntos (1–30 caracteres)',
    pinterest: 'Pinterest',
    pinterestError: 'Solo letras, dígitos, guiones bajos y puntos (3–30 caracteres)',
    achievements: 'Logros',
    playToEarn: '¡Juega para ganar logros!',
    recentScores: 'Puntuaciones recientes',
    profileUpdated: 'Perfil actualizado',
    avatarUpdated: 'Avatar actualizado',
    profileLinkCopied: '¡Enlace del perfil copiado!',
    signInToView: 'Inicia sesión para ver tu perfil',
    onlyJpgPngWebp: 'Solo JPEG, PNG o WebP',
  },

  publicProfile: {
    userNotFound: 'Usuario no encontrado',
    userNotExist: 'Este usuario no existe.',
  },

  share: {
    shareNotFound: 'Enlace no encontrado',
    shareExpired: 'Este enlace puede haber expirado o no existe.',
    playThisPlaylist: 'Jugar esta playlist',
    goToAudyn: 'Ir a Audyn',
  },

  room: {
    roomCode: 'Código de sala',
    waitingForOpponent: 'Esperando oponente...',
    shareCodeHint: 'Comparte el código o enlace. La sala expira en 30 minutos.',
    cancelRoom: 'Cancelar',
    opponent: 'Oponente',
    playAgain: 'Jugar de nuevo',
    wonBy: '¡Ganaste por {diff} puntos! 🏆',
    tie: '¡Empate!',
    lostBy: 'Perdiste por {diff} puntos',
    h2hChallenge: 'Desafío 1v1',
    roomLinkCopied: '¡Enlace de sala copiado!',
    challengeLinkCopied: '¡Enlace de desafío copiado! Envíalo a un amigo.',
    noPlaylist: 'Sin playlist seleccionada — carga una playlist primero.',
  },

  errorBoundary: {
    title: 'Algo salió mal.',
    message: 'Recarga la página para intentar de nuevo.',
    reload: 'Recargar',
  },

  languages: {
    en: 'English',
    hi: 'हिन्दी',
    es: 'Español',
    ja: '日本語',
    ko: '한국어',
  },
};

export default es;
